// ============================================================================
// PAIRING HEAP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'pairing-heap',
  name: 'Pairing Heap',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) amortized per operation',
    space: 'O(N)'
  },
  description: 'A priority queue data structure that is simpler to implement than Fibonacci heap while still having good amortized performance. Uses a multi-way tree structure and a two-pass merge operation for efficient deletions.'
};
